// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2HJq8","empty":"ModalGraph_empty__sLsif"};